// extracted by mini-css-extract-plugin
export default {"bg":"S26oeQ","closeButton":"_yN7lZ","title":"FH3ZK_","description":"XXs3CM","button":"aS1XFv"};